var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTitleP1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 233,
    viewBox: "0 0 458 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5599 0H120.142L209.702 245H178.915L153.727 174.65H45.9749L20.7862 245H-10L79.5599 0ZM144.281 148.05L100.55 24.85H99.1511L55.4207 148.05H144.281Z",
    fill: "#812456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.506 0H264.187L338.703 172.55H340.803L415.319 0H458V245H430.013V35.7H428.263L352.697 210H326.809L251.243 35.7H249.493V245H221.506V0Z",
    fill: "#812456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTitleP1);
export default __webpack_public_path__ + "static/media/footer-title-p1.79b62a9d51080ed23c20b442e1b8fbff.svg";
export { ForwardRef as ReactComponent };